import React from 'react';
import { string } from 'prop-types';

import { cn } from 'utils/style';

import './styles.scss';

function Button({ className, children, type }) {
  return (
    <button type={type} className={cn('button', className)}>
      {children}
    </button>
  )
}

Button.propTypes = {
  className: string,
  type: string,
}

export default Button;
